import defaultSettings from '@/settings'
const GET_WEB_MEANS = JSON.parse(sessionStorage.getItem('GET_WEB_MEANS'))

let name = ''

if (GET_WEB_MEANS) {
  for (const v of GET_WEB_MEANS) {
    if (v.layoutId == 'OFFICIAL_TEXT') {
      for (const i of v.imgs) {
        if (i.imgName == '官网名称') {
          name = i.layoutLink
        }
      }
    }
  }
}
const title = name || ''
// let title = name || '名山金融法庭'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
